import { Router } from '@angular/router'
import { NgModule } from '@angular/core'

import { SharedModule } from '../shared/shared.module'
import { VideoPlayerModule } from '../shared/video-player/video-player.module'
import { VideosComponent } from './videos.component'
import { VideosRoutingModule } from './videos-routing.module'
import { VideosResolver } from './videos.resolver'
import { VideoService } from '../shared/services/video.service'
import { TagsModule } from '../libs/tags/tags.module'
import { SlimHeaderModule } from '../libs/slim-header/slim-header.module'
import { PrimaryRelatedContentModule } from '../libs/primary-related-content/primary-related-content.module'
import { AuthorDateModule } from '../shared/author-avatar/author-date/author-date.module'
import { VideosAnalyticsService } from './videos-analytics.service'
import { AdhesionFooterModule } from '../libs/adhesion-footer/adhesion-footer.module'

@NgModule({
  imports: [
    SharedModule,
    VideosRoutingModule,
    VideoPlayerModule,
    TagsModule,
    SlimHeaderModule,
    PrimaryRelatedContentModule,
    AuthorDateModule,
    AdhesionFooterModule
  ],
  declarations: [VideosComponent],
  providers: [
    {
      provide: VideosResolver,
      useClass: VideosResolver,
      deps: [VideoService, Router]
    },
    VideoService,
    VideosAnalyticsService
  ],
  exports: [VideosComponent]
})
export class VideosModule {}
